import styles from './HeaderOrderSummary.module.css';
import ExpandySection from 'components/ExpandySection';
import ShoppingCart from '../svg/ShoppingCart.svg';
import ChevronLeft15 from '../svg/ChevronLeft15.svg';
import OrderSummaryRows from './OrderSummaryRows';
import OrderSummaryCosts from './OrderSummaryCosts';
import { observer } from 'mobx-react-lite';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useState } from 'react';
import { PromoCodeEntry } from 'components/enter/order-summary/PromoCodeEntry';
import TicketStack from 'components/dashboard/EntriesAndStats/TicketStack';

interface Props {}

const HeaderOrderSummary = observer((props: Props) => {
  const enterStore = useEnterStore();
  const [promoOpen, setPromoOpen] = useState(false);
  const [ticketsExpanded, setTicketsExpanded] = useState(false);

  return (
    <ExpandySection
      containerClassName={styles.container}
      expandedContainerClassName={styles.containerExpanded}
      expandButtonAlignment="right"
      headerContent={
        <div className={styles.header}>
          <ShoppingCart className={styles.cart} />
          <ChevronLeft15 className={styles.chevron} />
        </div>
      }
    >
      <div className={styles.content}>
        <h3 className={styles.heading + ' aboutUsTypographyHeaderMedium'}>
          Your order
        </h3>
        <hr />
        <div className={styles.entryContainer}>
          <TicketStack
            entries={enterStore.lines}
            withLoadingSkeleton={false}
            expanded={ticketsExpanded}
            hideExpandButton
          />
          <div className={styles.buttonContainer}>
            <button
              className={
                styles.promoLink + ' ' + (promoOpen ? styles.promoLinkOpen : '')
              }
              onClick={() => setPromoOpen((x) => !x)}
            >
              Got a code?
            </button>
            {enterStore.lines.length > 1 && (
              <button
                className={styles.expandLink}
                onClick={() => setTicketsExpanded((x) => !x)}
              >
                {ticketsExpanded ? 'Collapse' : 'Expand'}
              </button>
            )}
          </div>
          {promoOpen && (
            <div className={styles.promoPanel}>
              <PromoCodeEntry />
            </div>
          )}
        </div>
        <hr />
        <div>
          <OrderSummaryRows showDays />
        </div>
        <div className={styles.costsContainer}>
          <OrderSummaryCosts />
        </div>
        <span className="aboutUsTypographyBodySmall">
          <strong className={styles.cancelText}>👋 Cancel anytime 👋</strong>
        </span>
      </div>
    </ExpandySection>
  );
});

export default HeaderOrderSummary;
